import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import { useAppSelector } from '../../hooks';
import LoadingPanel from '../loading-panel/loading-panel';

function LoadingScreen() {
  const { liteMode } = useAppSelector((state) => state.user);
  return (
    <Box
      data-testid="loading-screen"
      style={{
        backgroundColor: 'background.default',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <LoadingPanel />
      {liteMode && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          Loading in Lite Mode
        </Typography>
      )}
    </Box>
  );
}

export default LoadingScreen;
